import { last } from "@pdfking/rfunc"
import { Composition } from "@pdfking/tfunc"
import split_filename from "./split_filename"

export default Composition(split_filename, last) as (filename: string) => string
